import { DomainModel } from 'domains/models';
import { MeetingType } from '../event/meeting_type';

interface Props {
  eventId: number;
  meetingType: MeetingType;
  isPrimary: boolean;
  url: string;
  meetingId: number | null;
}

export default class EventMeeting extends DomainModel {
  eventId: number;
  meetingType: MeetingType;
  isPrimary: boolean;
  url: string;
  meetingId: number | null;

  constructor(props: Props) {
    super(props);
    this._className = 'EventMeeting';
    this.eventId = props.eventId;
    this.meetingType = props.meetingType;
    this.isPrimary = props.isPrimary;
    this.url = props.url;
    this.meetingId = props.meetingId;
  }

  static permited = [];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }

  isValid(scopes: string[] | null = null) {
    super.beforeValidate();
    return super.isValid();
  }
}
